import { render } from "./Appheader.vue?vue&type=template&id=63448dec"
import script from "./Appheader.vue?vue&type=script&lang=js"
export * from "./Appheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__